// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}



.flipbook-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.page {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.page-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.allcomics-container {
  text-align: center;
  padding: 20px;
}

/* Contenedor del selector */
.comic-selector-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15px auto;
  width: 100%;
  max-width: 320px;
}

/* Estilos del selector */
.comic-selector {
  width: 100%;
  padding: 12px;
  font-size: 1rem;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(135deg, #1a73e8, #0044cc);
  border: none;
  border-radius: 25px;
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  appearance: none;
  text-align: center;
}

/* Estilos de la flecha */
.custom-arrow {
  position: absolute;
  right: 15px;
  color: #fff;
  font-size: 1rem;
  pointer-events: none;
  transition: transform 0.3s ease;
}

/* Animación de la flecha al enfocar */
.comic-selector:focus + .custom-arrow {
  transform: rotate(180deg);
}

/* Cambios al pasar el mouse */
.comic-selector:hover {
  background: linear-gradient(135deg, #1662c6, #0038a6);
}

/* Cambios cuando se selecciona */
.comic-selector:focus {
  background: linear-gradient(135deg, #0f4ea0, #002b7a);
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
}

/* Estilos de las opciones desplegables */
.comic-selector option {
  background-color: #f0f0f0;
  color: #000;
  padding: 10px;
  border-radius: 10px;
}

/* Spinner de carga */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.2);
  border-top: 4px solid #ff3b3b;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-container p {
  font-size: 1rem;
  color: #ff3b3b;
  font-weight: bold;
  margin-top: 10px;
}

/* Responsividad */
@media screen and (max-width: 600px) {
  .flipbook-container {
    width: 90%;
    margin: auto;
  }

  .page {
    width: 100%;
    height: auto;
  }

  .comic-selector {
    font-size: 0.9rem;
    padding: 10px;
  }
}




.allcomics-container {
  text-align: center;
  padding: 20px;
  background: #f4f4f400;
}

.comic-gallery {
  display: flex;
  overflow-x: auto;
  padding: 10px;
  gap: 15px;
  justify-content: center;
  margin-bottom: 20px;
}




/* Aumenta ligeramente el tamaño al pasar el mouse */
.comic-thumbnail:hover {
  transform: scale(1.05);
}

/* Flipbook */
.flipbook-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.loading-container {
  text-align: center;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #ddd;
  border-top-color: #9359b4;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}



/* Swiper */
.comic-swiper {
  margin: 20px auto;
  padding-bottom: 30px;
  width: 90%;
}

.swiper-button-prev, .swiper-button-next {
  color: #9359b4 !important;
}

.swiper-pagination-bullet {
  background: #9359b4 !important;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%; /* Asegura que el slide ocupa todo el espacio disponible */
  height: 220px;
  padding: 10vw;
  background: transparent;
  padding: 0;
}

/* Asegurar que las imágenes llenen todo el slide */
.comic-thumbnail {
  width: 90%;
  height: 90%;
  overflow: hidden;
}

.comic-thumbnail img {
  width: 90%;
  height: 90%;
  object-fit: cover;
}



/* Miniatura del cómic dentro del Swiper */
/* .comic-thumbnail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  text-align: center;
  overflow: hidden;
  transition: transform 0.3s ease;
  background: white;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.comic-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover; 
  border-radius: 5px;
} */`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;;AAIA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,qDAAqD;AACvD;;AAEA,iCAAiC;AACjC;EACE,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;;;;AAKA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;;;;AAKA,oDAAoD;AACpD;EACE,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;;AAIA,WAAW;AACX;EACE,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,EAAE,0DAA0D;EACvE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;;;AAIA,0CAA0C;AAC1C;;;;;;;;;;;;;;;;;GAiBG","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n.flipbook-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.page-image {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.allcomics-container {\n  text-align: center;\n  padding: 20px;\n}\n\n/* Contenedor del selector */\n.comic-selector-container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 15px auto;\n  width: 100%;\n  max-width: 320px;\n}\n\n/* Estilos del selector */\n.comic-selector {\n  width: 100%;\n  padding: 12px;\n  font-size: 1rem;\n  font-weight: bold;\n  color: #fff;\n  background: linear-gradient(135deg, #1a73e8, #0044cc);\n  border: none;\n  border-radius: 25px;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n  appearance: none;\n  text-align: center;\n}\n\n/* Estilos de la flecha */\n.custom-arrow {\n  position: absolute;\n  right: 15px;\n  color: #fff;\n  font-size: 1rem;\n  pointer-events: none;\n  transition: transform 0.3s ease;\n}\n\n/* Animación de la flecha al enfocar */\n.comic-selector:focus + .custom-arrow {\n  transform: rotate(180deg);\n}\n\n/* Cambios al pasar el mouse */\n.comic-selector:hover {\n  background: linear-gradient(135deg, #1662c6, #0038a6);\n}\n\n/* Cambios cuando se selecciona */\n.comic-selector:focus {\n  background: linear-gradient(135deg, #0f4ea0, #002b7a);\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);\n}\n\n/* Estilos de las opciones desplegables */\n.comic-selector option {\n  background-color: #f0f0f0;\n  color: #000;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n/* Spinner de carga */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 30px;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(255, 255, 255, 0.2);\n  border-top: 4px solid #ff3b3b;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-container p {\n  font-size: 1rem;\n  color: #ff3b3b;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n/* Responsividad */\n@media screen and (max-width: 600px) {\n  .flipbook-container {\n    width: 90%;\n    margin: auto;\n  }\n\n  .page {\n    width: 100%;\n    height: auto;\n  }\n\n  .comic-selector {\n    font-size: 0.9rem;\n    padding: 10px;\n  }\n}\n\n\n\n\n.allcomics-container {\n  text-align: center;\n  padding: 20px;\n  background: #f4f4f400;\n}\n\n.comic-gallery {\n  display: flex;\n  overflow-x: auto;\n  padding: 10px;\n  gap: 15px;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n\n\n\n/* Aumenta ligeramente el tamaño al pasar el mouse */\n.comic-thumbnail:hover {\n  transform: scale(1.05);\n}\n\n/* Flipbook */\n.flipbook-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.loading-container {\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid #ddd;\n  border-top-color: #9359b4;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n/* Swiper */\n.comic-swiper {\n  margin: 20px auto;\n  padding-bottom: 30px;\n  width: 90%;\n}\n\n.swiper-button-prev, .swiper-button-next {\n  color: #9359b4 !important;\n}\n\n.swiper-pagination-bullet {\n  background: #9359b4 !important;\n}\n\n.swiper-slide {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%; /* Asegura que el slide ocupa todo el espacio disponible */\n  height: 220px;\n  padding: 10vw;\n  background: transparent;\n  padding: 0;\n}\n\n/* Asegurar que las imágenes llenen todo el slide */\n.comic-thumbnail {\n  width: 90%;\n  height: 90%;\n  overflow: hidden;\n}\n\n.comic-thumbnail img {\n  width: 90%;\n  height: 90%;\n  object-fit: cover;\n}\n\n\n\n/* Miniatura del cómic dentro del Swiper */\n/* .comic-thumbnail {\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  text-align: center;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.comic-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; \n  border-radius: 5px;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
